<template>

  <!-- Persons Content -->
  <div
    class="persons-content">

    <swiper
      ref="swiper"
      :options="swiperOptions"
      class="persons-content__swiper">

      <swiper-slide
        :key="element.id"
        class="persons-content__slide"
        v-for="element in value.elements">

        <person-card
          :name="element.title"
          :caption="element.body"
          :text-color="value.textColor"
          class="card-shadow hover-scale-2"
          :image-link="getFileUrl(element.file, 400)"/>

      </swiper-slide>

    </swiper>

  </div>

</template>

<script>

  import PersonCard from '@src/components/card/person-card';

  export default {
    name: 'persons-content',
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PersonCard,
    },
    data() {
      return {
        swiperOptions: {
          slidesPerView: 'auto',
          spaceBetween: 30,
        },
      };
    },
  };

</script>

<style lang="scss">

  .persons-content {
    color: inherit;

    &__swiper {
      overflow: visible;
    }

    &__slide {
      max-width: 350px;
    }

    &__card {
      box-shadow: $card-shadow;
    }

    /*

    &__next-button,
    &__prev-button {
      width: 55px;
      height: 55px;
      color: white;
      display: block;
      border-radius: 50%;
      position: absolute;
      z-index: 3 !important;
      box-shadow: $card-shadow;
      background-color: $accent;

      &:after {
        top: 50%;
        left: 50%;
        font-size: 2rem;
        position: relative;
        display: inline-block;
        transform: translate(-50%, -50%);
      }

      @media (max-width: $breakpoint-xs) {
        display: none;
      }
    }

    &__next-button:after {
      left: 57%;
    }

    &__prev-button:after {
      left: 43%;
    }

    */
  }

</style>
